module.exports = __webpack_public_path__ + "images/Cans-fan-larger.png";